import React, { Component } from 'react';
import { Modal, Button, Input, message, Radio } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const RadioGroup = Radio.Group;

class SecEvaluation extends Component {
    state = {
        data: [],
        params: {},
        visible: false,
        loading: false,
        fileList: [],
    }

    show = (record = {}) => {
        const { evaluateRecordId, serveFeeType } = record;
        this.setState({
            params: { evaluateRecordId, serveFeeType },
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            data: [],
            params: {},
            visible: false,
            loading: false,
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    submit = () => {
        const { params } = this.state;
        const { secondEvaluationStatus, remark, evaluateRecordId, serveFeeType, needCoverData } = params;
        if (!secondEvaluationStatus) {
            return message.warning(`请选择是否需要二次评估`)
        }
        if (secondEvaluationStatus == 'NO_NEED_RE_EVALUATION' && !needCoverData) {
            return message.warning(`请选择是否需要覆盖最新评估参数`)
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.auditSecondEvaluation,
            data: {
                serveFeeType,
                secondEvaluationStatus,
                remark,
                evaluateRecordId,
                needCoverData,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.props.loadData();
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, params, loading } = this.state;
        const { secondEvaluationStatus, remark, needCoverData } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={`二次评估确认`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width="450px"
            >
                <div className="modal-content" style={{ padding: '30px 20px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{width: '50%'}}>{asterisk}是否需要二次评估：</div>
                            <div className="item-right" style={{width: '50%'}}>
                                <RadioGroup value={secondEvaluationStatus} onChange={e => this.handleChange(e.target.value, 'secondEvaluationStatus')}>
                                    <Radio value="NEED_RE_EVALUATION">是</Radio>
                                    <Radio value="NO_NEED_RE_EVALUATION">否</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                        {
                            secondEvaluationStatus && <li className="modal-item">
                                    <div className="item-left" style={{width: '50%'}}>{secondEvaluationStatus == 'NO_NEED_RE_EVALUATION' ? '不' : ''}需要二次评估原因：</div>
                                    <div className="item-right" style={{width: '50%'}}>
                                        <Input
                                            placeholder='请输入原因'
                                            style={{ width: 120 }}
                                            value={remark}
                                            onChange={e => this.handleChange(e.target.value, 'remark')}
                                        />
                                    </div>
                                </li>
                        }
                        {
                            secondEvaluationStatus == 'NO_NEED_RE_EVALUATION' && <li className="modal-item">
                                    <div className="item-left" style={{width: '50%'}}>{asterisk}是否需要覆盖最新评估参数：</div>
                                    <div className="item-right" style={{width: '50%'}}>
                                        <RadioGroup value={needCoverData} onChange={e => this.handleChange(e.target.value, 'needCoverData')}>
                                            <Radio value="1">是</Radio>
                                            <Radio value="0">否</Radio>
                                        </RadioGroup>
                                    </div>
                                </li>
                        }
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default SecEvaluation;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/SecEvaluation.js